/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { ApiDocsService } from './services/ApiDocsService';
import { ConnectionMissingPlansReportService } from './services/ConnectionMissingPlansReportService';
import { MonitoringService } from './services/MonitoringService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class RatingConfigReportClient {

    public readonly apiDocs: ApiDocsService;
    public readonly connectionMissingPlansReport: ConnectionMissingPlansReportService;
    public readonly monitoring: MonitoringService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? 'http://localhost:8097',
            VERSION: config?.VERSION ?? '1.0.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.apiDocs = new ApiDocsService(this.request);
        this.connectionMissingPlansReport = new ConnectionMissingPlansReportService(this.request);
        this.monitoring = new MonitoringService(this.request);
    }
}

